// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgSunLight = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 21.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75m-7.53-2.78a.75.75 0 1 1 1.06 1.06l-1 1a.75.75 0 1 1-1.06-1.06zm14 0a.75.75 0 0 1 1.06 0l1 1a.75.75 0 1 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06M12 5.25a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5m0 1.5a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5m-10 4.5a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5zm21 0a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1 0-1.5zM3.47 3.47a.75.75 0 0 1 1.06 0l1 1a.75.75 0 1 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m16 0a.75.75 0 1 1 1.06 1.06l-1 1a.75.75 0 1 1-1.06-1.06zM12 .25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 12 .25"
    />
  </svg>
);
export const SunLightIcon = forwardRef(SvgSunLight);
